import { render, staticRenderFns } from "./TemplateDetailsHeader.vue?vue&type=template&id=11008f40&scoped=true&"
import script from "./TemplateDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailsHeader.vue?vue&type=style&index=0&id=11008f40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11008f40",
  null
  
)

export default component.exports